<!--  -->
<template>
  <div class="template_box">
    <div>
      <!-- <div>+ 新建模板消息</div> -->
      <div class="task_box">
        <div>消息标题：</div>
        <el-input v-model="taskinput" style="width:400px" placeholder="用于内部区分消息，不影响消息内容" />
      </div>
      <!--  <div class="task_box">
        <div>群发对象：</div>
        <el-select v-model="massvalue" style="width:130px" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          />
        </el-select>
      </div> -->
      <div class="choose_plate">
        <div class="choose_text">选择平台：</div>
        <el-select v-model="palateid" placeholder="请选择平台" @change="chooseplate">
          <el-option
            v-for="item in plateoption"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div style="color:red;margin-top:10px">*更换平台会清空之前所填写的文本和链接</div>
      <div class="task_box">
        <div>选择模板：</div>
        <el-select v-model="templatevalue" style="width:300px" placeholder="请选择" @change="processTemplate">
          <el-option
            v-for="item in option"
            :key="item.id"
            :label="item.template_name + '(' + item.template_id_short + ')'"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="query_allbox">
        <div v-for="(item,index) in arr" :key="index" class="query_input">
          <div class="quert_textr">{{ item.title }}</div>
          <el-input
            v-model="item.textarea"
            type="textarea"
            autosize
            placeholder="请输入内容"
            @blur="handleInputBlur"
          />
          <el-color-picker v-model="item.color" @change="item.color = $event" />
          <el-popover
            placement="right"
            width="400"
            trigger="click"
          >
            <div style="display:flex;flex-wrap:wrap">
              <div v-for="(items,idx) in emoji_icon" :key="idx" @click="itemclaickw(index,idx)">
                {{ items }}
              </div>
            </div>
            <i slot="reference" class="el-icon-info" />
          </el-popover>
          <el-select v-model="item.addtifit" :disabled="palateid===''" filterable placeholder="添加标志" class="add_name">
            <el-option
              v-for="items in optionsr"
              :key="items.key"
              :label="items.value"
              :value="items.key"
            />
          </el-select>
          <el-link type="primary" @click="addsign(index,item.addtifit)">添加标志</el-link>
          <!-- @click="arr[index].textarea += item.addtifit" -->
        </div>
      </div>
      <div class="url_box">
        <div class="jump_text">点击跳转：</div>
        <el-radio v-model="linkradio" label="1">链接</el-radio>
      </div>
      <div class="task_box">
        <div>跳转链接：</div>
        <el-input v-model="jumpinput" style="width:400px" placeholder="请输入跳转链接" @blur="handleInputBlurtwo" />
      </div>
      <!-- <el-select v-model="jumpaddtifitr" :disabled="palateid===''" filterable placeholder="添加标志" style="margin:10px 10px 0px 70px">
        <el-option
          v-for="items in optionsr"
          :key="items.key"
          :label="items.value"
          :value="items.key"
        />
      </el-select> -->
      <!-- <el-link type="primary" @click="jumpaddsign">添加标志</el-link> -->
      <div class="choosecover">
        <div class="text_wei">
          添加链接活动：
        </div>
        <!-- <el-tag @click="addbookactivey">添加书城活动</el-tag> -->
        <div @click="beforehandleCommand">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              链接活动<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(items,indexr) in linkallarr" :key="indexr" :command="beforeHandleCommand(items.sign,items.identification)">{{ items.type_name }}</el-dropdown-item>
              <!-- <el-dropdown-item command="a">添加书城活动</el-dropdown-item>
              <el-dropdown-item command="b">添加红包活动</el-dropdown-item>
              <el-dropdown-item command="c">添加书城链接活动</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="save_box">
        <el-button size="small" type="primary" :disabled="disabledsave" @click="save">保存</el-button>
      </div>
    </div>
    <div class="phone_box">
      <div class="phone_content">
        <div>{{ choosetaskinput }}</div>
        <div class="phone_data">{{ getCurrentTime() }}</div>
        <div class="phone_contentse">
          <div v-for="(itemw,idxr) in arr" :key="idxr" class="phone_item">
            {{ itemw.title }}:{{ itemw.textarea }}
          </div>
        </div>
      </div>
    </div>
    <!-- 书城活动列表 -->
    <el-dialog title="选择活动" :visible.sync="bookctyactivitiesVisible" append-to-body width="40%">
      <bookctyactivities ref="bookctyactivitiesbox" @callbadwr="callbadwr" />
    </el-dialog>
    <!-- 发红包活动列表 -->
    <el-dialog title="选择红包" :visible.sync="redbao" append-to-body width="40%">
      <reddialog ref="chooseredbao" @redcallback="redcallback" />
    </el-dialog>
    <!-- 书城链接活动 -->
    <el-dialog title="选择书城链接" :visible.sync="sclink" append-to-body width="50%">
      <booklinkdialog ref="sclinkview" @sclinkcallback="sclinkcallback" />
    </el-dialog>
  </div>
</template>

<script>
import emojiicon from '../js/expression.js'
import { customerlogo, getTemplateList, createTemplateMessage, getlinktypeslist } from '@/api/sourceMaterial.js'
import bookctyactivities from './bookctyactivities'
import reddialog from './reddialog'
import booklinkdialog from './booklinkdialog'
export default {
  components: {
    bookctyactivities,
    reddialog,
    booklinkdialog
  },
  props: {
    plateoption: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      disabledsave: false,
      optionsr: [],
      taskinput: '', // 任务名称
      massvalue: '', // 群发选择字段
      templatevalue: '', // 选择模板字段
      linkradio: '1', // 链接radio
      jumpinput: '', // 跳转链接
      emoji_icon: emojiicon.emoji_icon, // 表情
      options: [{
        id: '1',
        label: '全部用户'
      }, {
        id: '2',
        label: '个别用户'
      }],
      option: [], // 选择模版
      arr: [],
      blurIndex: null,
      blurIndexrwo: null,

      jumpaddtifitr: null,
      palateid: '',
      choosetaskinput: '',
      bookctyactivitiesVisible: false,
      redbao: false,
      bookindex: null, // 模板添加书城活动 和红包活动索引值 他是多个 要保存索引值
      sclink: false,
      linkallarr: [],
      messageload: false,
      storagetype: null
    }
  },
  beforeDestroy() {
    if (window.JSON.parse(window.localStorage.getItem('customerServiceFatherTypeStorage') || 0) === 8) {
      if (!this.messageload) {
        const data = {
          taskinput: this.taskinput,
          palateid: this.palateid,
          templatevalue: this.templatevalue,
          linkradio: this.linkradio,
          arr: this.arr,
          jumpinput: this.jumpinput,
          linkallarr: this.linkallarr
        }
        window.localStorage.setItem('TemplatemessageMassageStorage', JSON.stringify(data))
      } else {
        window.localStorage.removeItem('TemplatemessageMassageStorage')
        window.localStorage.removeItem('customerServiceTypeStorage')
        // window.localStorage.removeItem('customerServiceFatherTypeStorage')
      }
    }
  },
  created() {
    this.getTemplateList()
    window.ak = this
  },
  mounted() {
    this.getlocalStorage()
  },
  methods: {
    getlocalStorage() {
      if (window.JSON.parse(window.localStorage.getItem('customerServiceFatherTypeStorage')) === 8) {
        const type = window.JSON.parse(window.localStorage.getItem('customerServiceTypeStorage') || '2')
        const res = window.JSON.parse(window.localStorage.getItem('TemplatemessageMassageStorage') || '{}')
        // eslint-disable-next-line eqeqeq
        if (type == '2') {
          if (Object.keys(res).length !== 0) {
            this.taskinput = res.taskinput
            this.palateid = res.palateid
            this.templatevalue = res.templatevalue
            this.linkradio = res.linkradio
            this.arr = res.arr
            this.jumpinput = res.jumpinput
            this.linkallarr = res.linkallarr
          }
        }
      }
    },
    gettype(type) {
      this.storagetype = type
    },
    beforeHandleCommand(sign, identification) {
      return {
        'sign': sign,
        'identification': identification
      }
    },
    beforehandleCommand() {
      if (this.palateid === '') {
        this.$message.error('请选择平台')
        return
      }
    },
    // 获取链接类型
    async getlinktypesalllist() {
      const data = await getlinktypeslist({
        platform_id: this.palateid
      })
      this.linkallarr = data.data
      console.log('data222', data)
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    // 获取光标所在位置的index
    handleInputBlurtwo(e) {
      this.blurIndexrwo = e.srcElement.selectionStart
    },
    // 获取客服消息标识
    async getcustomercation() {
      const data = await customerlogo({
        platformId: this.palateid
      })
      this.optionsr = data.data.list
      console.log('获取客服消息标识1111', data.data.list)
    },

    // 获取模版消息
    async getTemplateList() {
      const data = await getTemplateList()
      this.option = data.data.list
    },
    itemclaickw(index, idx) {
      this.arr[index].textarea = this.arr[index].textarea.slice(0, this.blurIndex) + this.emoji_icon[idx] + this.arr[index].textarea.slice(this.blurIndex)
      // this.arr[index].textarea += this.emoji_icon[idx]
    },
    async save() {
      console.log('this.arr', this.arr)
      const data = {
        variable_value: {}
      }
      this.arr.forEach((item) => {
        data.variable_value[item.key] = {
          value: item.textarea,
          color: item.color
        }
      })
      const filter = this.option.filter(item => item.id === this.templatevalue)
      data.template_id_short = filter.length ? filter[0].template_id_short : null
      data.url = this.jumpinput
      data.title = this.taskinput
      data.platform_id = this.palateid
      // this.disabledsave = true
      if (this.verification(data)) {
        const res = await createTemplateMessage(data)
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        console.log(res)
        this.$emit('close')
        // this.disabledsave = false
      }
      this.messageload = true
    },
    getCurrentTime() {
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      return mm + '月' + dd
    },

    // 处理模版
    processTemplate(index) {
      this.option.forEach((item) => {
        if (item.id === index) {
          this.choosetaskinput = item.template_name
        }
      })
      // this.choosetaskinput = this.option[index].templateName
      const newArr = this.option.filter(item => item.id === index)[0].variable
      newArr.forEach((item) => {
        this.$set(item, 'color', '')
        this.$set(item, 'textarea', '')
        this.$set(item, 'addtifit', '')
      })
      this.arr = newArr
    },

    // 验证消息
    verification(data) {
      if (!data.title || !data.template_id_short || !data.variable_value) {
        let message = null
        if (!data.title) {
          message = '任务名称不能为空'
        // eslint-disable-next-line eqeqeq
        } else if (this.palateid == '') {
          message = '请选择平台'
        } else if (!data.template_id_short || !data.variable_value) {
          message = '请选择模版'
        }
        this.$message({
          message,
          type: 'warning'
        })
        return false
      }
      for (const key in data.variable_value) {
        const item = data.variable_value[key]
        console.log('key', key, 'item', item)
        // eslint-disable-next-line eqeqeq
        // if (!item.value && key != 'remark') {
        if (!item.value) {
          this.$message({
            message: '模版消息不能为空',
            type: 'warning'
          })
          return false
        }
      }

      return true
    },
    // 添加标志
    addsign(index, item) {
      this.bookindex = index
      // eslint-disable-next-line eqeqeq
      if (item == '${activity_}') {
        this.bookctyactivitiesVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bookctyactivitiesbox.send(this.palateid, 4)
        }, 100)
        return
      }
      // eslint-disable-next-line eqeqeq
      if (item == '${red_pack_}') {
        this.redbao = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chooseredbao.send(this.palateid, 4)
        }, 100)
        return
      }
      // @click="arr[index].textarea += item.addtifit"
      this.arr[index].textarea = this.arr[index].textarea.slice(0, this.blurIndex) + item + this.arr[index].textarea.slice(this.blurIndex)
    },
    jumpaddsign() {
      if (this.jumpaddtifitr === null) {
        this.$message({
          message: '请选择标志',
          type: 'error'
        })
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.jumpaddtifitr == '${activity_}') {
        this.bookctyactivitiesVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bookctyactivitiesbox.send(this.palateid, 3)
        }, 100)
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.jumpaddtifitr == '${red_pack_}') {
        this.redbao = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chooseredbao.send(this.palateid, 3)
        }, 100)
        return
      }
      this.jumpinput = this.jumpinput.slice(0, this.blurIndexrwo) + this.jumpaddtifitr + this.jumpinput.slice(this.blurIndexrwo)
    },
    // 选择书城活动回调
    callbadwr(item, type) {
      this.bookctyactivitiesVisible = false
      // eslint-disable-next-line eqeqeq
      if (type == 3) {
        this.jumpinput = ''
        this.jumpinput = this.jumpinput.slice(0, this.blurIndexrwo) + item.sign + this.jumpinput.slice(this.blurIndexrwo)
      }
      // eslint-disable-next-line eqeqeq
      if (type == 4) {
        this.arr[this.bookindex].textarea = this.arr[this.bookindex].textarea.slice(0, this.blurIndex) + item.sign + this.arr[this.bookindex].textarea.slice(this.blurIndex)
      }
    },
    // 选择红包活动回调
    redcallback(item, type) {
      this.redbao = false
      // eslint-disable-next-line eqeqeq
      if (type == 3) {
        this.jumpinput = ''
        this.jumpinput = this.jumpinput.slice(0, this.blurIndexrwo) + item.sign + this.jumpinput.slice(this.blurIndexrwo)
      }
      // eslint-disable-next-line eqeqeq
      if (type == 4) {
        this.arr[this.bookindex].textarea = this.arr[this.bookindex].textarea.slice(0, this.blurIndex) + item.sign + this.arr[this.bookindex].textarea.slice(this.blurIndex)
      }
    },
    // 选择链接活动回调
    sclinkcallback(item) {
      this.sclink = false
      this.jumpinput = ''
      this.jumpinput = this.jumpinput.slice(0, this.blurIndexrwo) + item.sign_template_no + this.jumpinput.slice(this.blurIndexrwo)
    },
    chooseplate() {
      this.optionsr = []
      this.jumpaddtifitr = null
      console.log('arr', this.arr)
      if (this.arr.length !== 0) {
        this.arr.forEach((item) => {
          item.addtifit = ''
          // item.textarea = ''
        })
      }
      this.getcustomercation()
      this.getlinktypesalllist()
      this.jumpinput = ''
    },
    handleCommand(command) {
      if (this.palateid === '') {
        this.$message.error('请选择平台')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_activity') {
        this.bookctyactivitiesVisible = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bookctyactivitiesbox.send(this.palateid, 3)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'red_packet_activity') {
        this.redbao = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.chooseredbao.send(this.palateid, 3)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == 'platform_promotion_link') {
        this.sclink = true
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.sclinkview.send(this.palateid)
        }, 100)
      }
      // eslint-disable-next-line eqeqeq
      if (command.identification == '') {
        this.jumpinput = ''
        this.jumpinput = command.sign
      }
    },
    edit(item, type) {
      this.palateid = item.platform_id
      this.taskinput = item.title + '-复用'
      this.templatevalue = item.templateId
      this.jumpinput = item.url
      this.choosetaskinput = item.templateName
      this.arr = item.preview.map(item => { // item是数组中的每一个值
        return {
          color: item.color,
          textarea: item.value,
          title: item.title,
          key: item.key,
          addtifit: ''
        }
      })
      this.getcustomercation()
      this.getlinktypesalllist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.task_box{
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.template_box{
  margin-top:20px;
  display: flex;
}
.query_input{
  background: #f5f5f5;
  width: 650px;
  display: flex;
  align-items: center;
  padding: 13px;
}
.query_allbox{
  margin-top: 20px;
}
.quert_textr{
  flex-shrink: 0;
  margin-right: 10px;
}
.url_box{
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.jump_text{
  margin-right: 10px;
}
.save_box{
  margin-top: 15px;
}
.phone_box{
  background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
  background-size: 100% 100%;
  width: 300px;
  height: 600px;
  margin-left: 100px;
  position: relative;
}
.phone_content{
  width: 240px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
  padding: 10px 25px 14px 11px;
  box-sizing: border-box;
}
.phone_data{
  color: #d1dfff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.phone_contentse{
  /* margin-top: 10px; */
}
.phone_item{
  margin-bottom: 10px;
}
.choose_plate{
  display: flex;
  align-items: center;
  margin: 20px 0px 10px 0px;
}
.choose_text{
  font-size: 14px;
  color: #606266;
}
.choosecover{
  display: flex;
  align-items: center;
  margin-top: 20px;
}
</style>
